import { useEventDebuggerTableContext } from 'app/event-monitoring/event-debugger/event-debugger-table/EventDebuggerTableContext';

const EVENTS_REQUESTED_OPTIONS = [
  { label: '1', value: '1' },
  { label: '3', value: '3' },
  { label: '5', value: '5' },
  { label: '10', value: '10' },
  { label: '30', value: '30' },
  { label: '50', value: '50' },
  { label: '100', value: '100' },
  { label: '250', value: '250' },
];

const STATIC_PER_PAGE_SELECT_PROPS = {
  size: 'small',
  variant: 'outlined',
  label: 'Events',
};

export default function useEventsRequestedSelectProps() {
  const { eventsRequested, onEventsRequestedChange } = useEventDebuggerTableContext();

  const onChange = event => {
    onEventsRequestedChange(event.target.value);
  };

  const props = {
    ...STATIC_PER_PAGE_SELECT_PROPS,
    options: EVENTS_REQUESTED_OPTIONS,
    value: eventsRequested,
    onChange,
  };

  return props;
}
